export default __webpack_public_path__ + "static/media/Website.f91dd73a.svg";